import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { resetStep2 } from "../../reducers/Audit";
import {
  getAuditReivewDetails,
  updateAuditPlanning,
  getorganization,
  getThemes,
  getSequenceList,
} from "../../api/common";
import SuggestionCard from "../../Components/SuggestionCard";
import { ERROR_MESSAGE } from "../../constants";
import { RootState } from "../../store";
import {
  getTeamMembersSelectOptions,
  getTeamleadSelectOptions,
  decrypt,
  getSessionStorage,
  getAuditeeSelectOptions,
} from "../../utils";
import PageContainer from "../PageContainer";
import Alert from "../../Components/AlertPopup";
import UpdateRegistration, {
  UpdateData,
} from "../../Containers/UpdateAuditPlanning";

const UpdateAuditPlanning = () => {
  const { id } = useParams();
  const staticData = useSelector((state: RootState) => state.staticData);
  const [userData, setuserData] = useState<string[]>([]);
  const encryptedUser = getSessionStorage("user");
  const [auditTypesList, setAuditTypeList] = useState<any>([]);
  const [auditeesList, setAuditeesList] = useState<any>([]);
  const [teamleadList, setTeamLeadList] = useState<any>([]);
  const [membersList, setMembersList] = useState<any>([]);
  const [getTheme, setTheme] = useState<any>([]);
  const [getOrganization, setorganization] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    ERROR_MESSAGE.API_ERROR_MESSAGE
  );
  const [teamList, setTeamList] = useState<any>([]);
  const [showSuggestionCard, setShowSuggestionCard] = useState(false);

  const [suggestions, setSuggestions] = useState<any>([]);
  const [auditUpdatedata, setAuditUpdateData] = useState();
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [sequence, setSequence] = useState<any>();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const useForceUpdate = () => {
    const [, setTick] = useState(0);
    const update = useCallback(() => {
      setTick((tick) => tick + 1);
    }, []);
    return update;
  };

  useEffect(() => {
    if (encryptedUser) {
      const decryptedData = decrypt(encryptedUser);
      const user = JSON.parse(decryptedData);
      setuserData(user);
    }
    const fetchData = async () => {
      const teamMembersOptions = await getTeamMembersSelectOptions();
      const teamOptions = await getAuditeeSelectOptions();
      const teamLeadOption = await getTeamleadSelectOptions();
      const AuditUpdate = await getAuditReivewDetails(parseInt(id!));
      const Organization = await getorganization();
      const OrgThemes = await getThemes();
      const SequenceList = await getSequenceList();

      setTheme(OrgThemes);
      setorganization(Organization);
      setAuditUpdateData(AuditUpdate);
      setTeamLeadList(teamLeadOption);
      setMembersList(teamMembersOptions);
      setTeamList(teamOptions);
      setSequence(SequenceList);
    };

    if (staticData.jobRole && staticData.jobRole.length > 0) {
      setAuditTypeList(staticData.jobRole);
    }
    fetchData();
  }, [dispatch, staticData.jobRole, id]);

  const submitRequests = (auditData: UpdateData) => {
    setLoading(true);

    const request = {
      auditLevel: Number(auditData.auditLevel),
      fromDate: auditData.auditeeInfo.startDate.toISOString().split("T")[0],
      toDate: auditData.auditeeInfo.endDate.toISOString().split("T")[0],
      slaTime: auditData.auditSla,
      kickOffMeeting: auditData.kickOffMeeting ?? true,
      auditorMembers: auditData.auditeeInfo.members ?? [],
      organizationId: auditData.auditeeInfo.organizations ?? [],
      auditThemeId: auditData.auditeeInfo.auditThemes ?? [],
      auditSequences: auditData.auditeeInfo.sequencedata ?? [],
      auditeeOrganizationRequestData:
        auditData.auditeeInfo.organizationDetailsData ?? [],
      escalationDay: auditData.escalationDay,
    };
    if (id) {
      updateAuditPlanning(id, request)
        .then(() => {
          setLoading(false);
          setShowToast(true);
          setTimeout(() => navigate("/audit-scheduled"), 4000);
        })
        .catch((error) => {
          setLoading(false);
          setErrorMessage(ERROR_MESSAGE.API_ERROR_MESSAGE);
          setShowErrorToast(true);
        });
    }
  };

  return (
    <PageContainer show={false}>
      <div style={{ width: "100%" }}>
        <SuggestionCard
          visible={showSuggestionCard}
          onDismissed={() => {
            setShowSuggestionCard(false);
          }}
          message={suggestions}
          loading={suggestionLoading}
        />
      </div>
      <div style={{ width: "100%" }}>
        <UpdateRegistration
          auditUpdatedata={auditUpdatedata}
          teamleadList={teamleadList}
          userData={userData}
          membersList={membersList}
          auditTypeList={auditTypesList}
          auditeesList={auditeesList}
          loading={loading}
          showToast={showToast}
          getTheme={getTheme}
          sequence={sequence}
          getOrganization={getOrganization}
          onSubmit={(data: UpdateData) => {
            submitRequests(data);
          }}
        />
      </div>

      <Alert
        type="error"
        show={showErrorToast}
        onClose={() => setShowErrorToast(false)}
        message={errorMessage}
      />
      <Alert
        show={showToast}
        onClose={() => {
          setShowToast(false);
          dispatch(resetStep2()); // Clear sequence and theme data after successful update
          navigate("/audit-scheduled");
        }}
        message={"The audit plan has been updated successfully!!"}
      />
    </PageContainer>
  );
};

export default UpdateAuditPlanning;
